import React from 'react';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Select from 'react-select';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';

const schema = Yup.object().shape({
  codigo_titulo_ocorrencia: Yup.number().nullable().required('Título obrigatório'), // V-23
  texto: Yup.string().required('Observação obrigatória'), // V-24
});

const OcorrenciaForm = ({ titulos, onSubmit }) => {
  const opcoesTitulos = (titulos || []).map((t) => {
    const texto = t.titulo || t.descricao || String(t.codigo);
    return {
      value: t.codigo,
      label: `${t.codigo} - ${texto}`,
    };
  });

  const initialValues = { codigo_titulo_ocorrencia: null, texto: '' };

  const handleSubmit = async (values, formikBag) => {
    try {
      await onSubmit(values);
      formikBag.resetForm();
    } finally {
      formikBag.setSubmitting(false);
    }
  };

  return (
    <div className="mb-3">
      <strong style={{ fontSize: '0.9rem' }}>Nova Ocorrência</strong>
      <Formik
        initialValues={initialValues}
        validationSchema={schema}
        onSubmit={handleSubmit}
      >
        {(formik) => (
          <Form onSubmit={formik.handleSubmit} className="mt-2">
            <Form.Group className="mb-2">
              <Form.Label style={{ fontSize: '0.85rem' }} className="font-weight-bold">
                Título *
              </Form.Label>
              <Select
                placeholder="Selecione o título..."
                styles={customStyles}
                components={{ DropdownIndicator }}
                options={opcoesTitulos}
                value={
                  opcoesTitulos.find(
                    (t) => t.value === formik.values.codigo_titulo_ocorrencia
                  ) || null
                }
                onChange={(opt) =>
                  formik.setFieldValue(
                    'codigo_titulo_ocorrencia',
                    opt ? opt.value : null
                  )
                }
              />
              {formik.touched.codigo_titulo_ocorrencia &&
                formik.errors.codigo_titulo_ocorrencia && (
                  <div className="text-danger" style={{ fontSize: '0.8rem' }}>
                    {formik.errors.codigo_titulo_ocorrencia}
                  </div>
                )}
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label style={{ fontSize: '0.85rem' }} className="font-weight-bold">
                Observação *
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="texto"
                value={formik.values.texto}
                onChange={formik.handleChange}
                isInvalid={formik.touched.texto && !!formik.errors.texto}
                placeholder="Descreva a ocorrência..."
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.texto}
              </Form.Control.Feedback>
            </Form.Group>

            <Row>
              <Col className="text-right">
                <Button
                  variant="primary"
                  type="submit"
                  disabled={formik.isSubmitting}
                  size="sm"
                >
                  {formik.isSubmitting ? 'Salvando...' : 'Adicionar Ocorrência'}
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default OcorrenciaForm;
